import createIcon from '../../createIcon';

/**
 * @component @name Boy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNy41QzEyLjk3IDcuNSAxMy43NSA2LjcyIDEzLjc1IDUuNzVDMTMuNzUgNC43OCAxMi45NyA0IDEyIDRDMTEuMDMgNCAxMC4yNSA0Ljc4IDEwLjI1IDUuNzVDMTAuMjUgNi43MiAxMS4wMyA3LjUgMTIgNy41Wk0xNCAyMFYxNUgxNVYxMC41QzE1IDkuNCAxNC4xIDguNSAxMyA4LjVIMTFDOS45IDguNSA5IDkuNCA5IDEwLjVWMTVIMTBWMjBIMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Boy = createIcon('Boy', [
  [
    'path',
    {
      d: 'M12 7.5C12.97 7.5 13.75 6.72 13.75 5.75C13.75 4.78 12.97 4 12 4C11.03 4 10.25 4.78 10.25 5.75C10.25 6.72 11.03 7.5 12 7.5ZM14 20V15H15V10.5C15 9.4 14.1 8.5 13 8.5H11C9.9 8.5 9 9.4 9 10.5V15H10V20H14Z',
      key: '1xb4qi',
    },
  ],
]);

export default Boy;
